import GoodsEnum from '../enums/goodsEnum';

export default class Cart {
    static ajax = undefined;

    static _updateProduct(object) {
        return $.ajax({
            type: 'POST',
            url: '/cart/update-product',
            data: {
                'product_id': object.productId,
                'type': object.productType,
                'count': object.quantity,
            },
            dataType: 'json',
            beforeSend: function () {
                if (object.beforeSendCallback) {
                    object.beforeSendCallback();
                }
            },
            success: function (response) {
                if (response.status === 'OK') {
                    if (response.hasOwnProperty('totalAmount')) {
                        App.updateCounters(null, null, null, response.totalAmount);
                    }

                    if (object.successCallback) {
                        object.successCallback(response);
                    }
                }
            }
        });
    }

    static change(productType, productId, quantity, delta) {
        let prevRequest = this.ajax;

        this.ajax = this._updateProduct({
            productType,
            productId,
            quantity,
            beforeSendCallback: function () {
                if (prevRequest) {
                    prevRequest.abort();
                }
            },
            successCallback: function (response) {
                if (productType === GoodsEnum.product) {
                    if (response.hasOwnProperty('modelForAnalytics')) {
                        App.analytics.ecommerceCartItemChange(response.modelForAnalytics, delta);

                        if (response.hasOwnProperty('totalPrice')) {
                            App.analytics.carrotQuestCartItemChange(response.modelForAnalytics, delta, response.totalPrice);
                        }
                    }
                }
            }
        });
    }

    static remove(productType, productId) {
        this._updateProduct({
            productId,
            productType,
            quantity: 0,
        });
    }

    static checkOut($this, url) {
        // TODO: request is done. Move to Enum
        if (this.ajax && this.ajax.readyState != 4) {
            let wait = setInterval(() => {
                if (this.ajax.readyState == 4) {
                    $this.removeClass('pending');
                    $(location).attr('href', url);
                    
                    clearInterval(wait);
                }
            }, 200);
        } else {
            $this.removeClass('pending');
            $(location).attr('href', url);
        }
    }
}